import { nip19 } from 'nostr-tools';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import NotFound from './NotFound';
import { PUZZLE_KIND } from '@/lib/puzzle';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();
  const navigate = useNavigate();

  // Decode the identifier. This runs every render but is cheap.
  const decoded = useMemo(() => {
    if (!identifier) return null;
    try {
      return nip19.decode(identifier);
    } catch {
      return null;
    }
  }, [identifier]);

  const isPuzzleNaddr = decoded?.type === 'naddr' &&
    (decoded.data as { kind?: number }).kind === PUZZLE_KIND;

  // Redirect puzzle naddr to /play/:naddr.
  useEffect(() => {
    if (isPuzzleNaddr && identifier) {
      navigate(`/play/${identifier}`, { replace: true });
    }
  }, [isPuzzleNaddr, identifier, navigate]);

  // Invalid identifier.
  if (!decoded) {
    return <NotFound />;
  }

  // If it's a puzzle naddr, render nothing (we're redirecting).
  if (isPuzzleNaddr) {
    return null;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile':
      // AI agent should implement profile view here
      return <div>Profile placeholder</div>;

    case 'note':
      // AI agent should implement note view here
      return <div>Note placeholder</div>;

    case 'nevent':
      // AI agent should implement event view here
      return <div>Event placeholder</div>;

    case 'naddr':
      // AI agent should implement addressable event view here
      return <div>Addressable event placeholder</div>;

    default:
      return <NotFound />;
  }
}
